import {
    TREE_DATA
} from '../mutation-types';

// initial state
const state = {
    all: []
};

// mutations
const mutations = {
    [TREE_DATA] (state, data) {
        state.all = data;
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./E:/vue/bh-vue-demo/src/vuex/modules/tree.js